<div class="details-block details-block__contacts" 
	[ngClass]="{'has-details': INDRA_hasContactDetails(), 'no-pointer-events' : no_edit}" 
	tabindex=0 
	[attr.aria-label]="('bookingDetails.aria.listBookingContacts' | ibeadmin | async)">
	
	<ul class="grid" *ngIf="INDRA_hasContactDetails()">
		<li *ngFor="let contact of contacts; let index = index" class="col-6 col-tp-6 col-p-12">
			<article>
				<div class="details-block__content">
					<div class="details-block__header" [ngStyle]="INDRA_printLinkClasses()">
						<div class="details-block__title">
							<h3 class="title-h5" skeletonLoader [translationKey]="contact.labelKey">
								{{ INDRA_printLabel(contact) | async }}
							</h3>
							<span class="description" skeletonLoader [translationKey]="contact.descriptionKey">
								{{ INDRA_printDescription(contact) | async }}
							</span>
						</div>
					</div>
					<div class="details-block__details">
						<div *ngFor="let contact_value of contact.values">
							<span *ngIf=INDRA_hasContactValue(contact_value) class="value" skeletonLoader [translationKey]="contact_value.labelKey">
								<span class="label">
									{{ INDRA_printContactLabel(contact_value) | async }}: 
								</span>
								{{ INDRA_printContactValue(contact_value) }}
							</span>
							<a *ngIf="!INDRA_hasContactValue(contact_value) && !no_edit" 
								(click)="INDRA_handleOpenSidebar()" 
								[attr.aria-label]="('bookingDetails.label.openDialogToAdd' | ibeadmin | async) + INDRA_printContactLabel(contact_value) + ('bookingDetails.label.contactLabel' | ibeadmin | async)" 
								class="link" 
								href="javascript:;" 
								role="button"
							>
								<span skeletonLoader [translationKey]="'bookingDetails.text.add'">
									{{ 'bookingDetails.text.add' | ibeadmin | async }} 
									{{ INDRA_printContactLabel(contact_value) | async }} 
									{{ 'bookingDetails.text.contact' | ibeadmin | async }}
								</span>
							</a>
						</div>
					</div>
					<div *ngIf="INDRA_shouldShow(index) && !no_edit && !INDRA_isGroupBooking()" 
						class="details-block__edit">
						<a (click)="INDRA_handleOpenSidebar()" 
							aria-label="('bookingDetails.aria.openDialogToEditContacts' | ibeadmin | async)" 
							class="link" 
							href="javascript:;" 
							role="button"
						>
							<span skeletonLoader [translationKey]="INDRA_printLinkLabelKey()">
								{{ INDRA_printLinkLabel() | async }}
							</span>
						</a>
					</div>
				</div>
			</article>
		</li>
	</ul>

	<div *ngIf="!INDRA_hasContactDetails()" class="details-block__add" >
		<button 
			(click)="INDRA_handleOpenSidebar()" 
			class="button" 
			attr.aria-label="{{ 'bookingDetails.label.openAddContactDetails' | ibeadmin | async }}"
		>
			<span skeletonLoader [translationKey]="'bookingDetails.text.addContactDetails'">
				{{ 'bookingDetails.text.addContactDetails' | ibeadmin:'':false | async }}
			</span>
		</button>
	</div>
</div>
